"use strict";

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  background: ", ";\n  ", ";\n\n  &:hover {\n    color: ", ";\n    background: ", ";\n    border: ", ";\n  }\n\n  &:active {\n    color: ", ";\n    outline: none;\n  }\n\n  &:disabled {\n    background-color: ", ";\n    cursor: not-allowed;\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var Button_1 = require("./Button");

exports.SecondaryButton = styled_components_1.default(Button_1.Button).attrs({})(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.copy;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.capsFontStyle;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.copy;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.copy;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.accentGradientDark;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.white;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.disabled;
});